module.exports = __webpack_public_path__ + "img/Project_edited_clicked.e0dab431.svg";